'use client';

import React from 'react';
import {
  EnablementAction,
  useSafeEnablement,
} from '../contexts/EnablementContext';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'ui';

export const withEnablement = <T extends object>(
  Component: React.FC<T>,
  action?: EnablementAction,
) => {
  return function EnablementElement(props: T) {
    const enablement = useSafeEnablement();

    if (!enablement) return <Component {...props} />;

    // A partial block can exempt specific actions (e.g. file upload / messaging
    // on a fraud-locked claim), keeping them enabled while everything else is
    // disabled.
    const isExempt = !!action && !!enablement.exemptActions?.includes(action);

    if (enablement.disabled && !isExempt)
      return (
        <TooltipProvider delayDuration={200}>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className='cursor-not-allowed'>
                <div className='pointer-events-none opacity-50'>
                  <Component {...props} />
                </div>
              </div>
            </TooltipTrigger>
            <TooltipContent>
              {enablement.reason || 'No puedes realizar esta acción'}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );

    return <Component {...props} />;
  };
};
